import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconMainMenu = (props) => {
  props = Object.assign({viewBox: '-15 0 110 110'}, props);
  return (
    <SvgIcon {...props}>
      <g>
	  <path
   d="M 2.167,0 V 73.199 H 91.635 V 0 Z M 89,69.99975 l -84,5e-4 v -67 l 84,-5e-4 z" />
		<path
   d="m 27.607,34.385 -8.45,8.874 v 20.349 c 0,0.516 0.419,0.936 0.936,0.936 h 10.688 c 0.517,0 0.936,-0.419 0.936,-0.936 V 35.461 l -2.926,-1.076 z" />
		<path
   d="m 52.504945,42.913 h -10.687 c -0.518,0 -0.937,0.419 -0.937,0.936 v 19.758 c 0,0.517 0.419,0.937 0.937,0.937 h 10.687 c 0.517,0 0.936,-0.419 0.936,-0.937 V 43.848 c 0,-0.516 -0.419,-0.935 -0.936,-0.935 z" />
		<path
   d="m 71.892,22.785 -2.305,-1.926 -6.339,7.097 v 35.651 c 0,0.516 0.419,0.936 0.937,0.936 h 10.688 c 0.517,0 0.936,-0.419 0.936,-0.936 V 23.095 c -0.052,0.03 -0.099,0.067 -0.152,0.094 -0.485,0.254 -1.03,0.388 -1.578,0.388 -0.801,10e-4 -1.575,-0.28 -2.187,-0.792 z" />
		<path
   d="M14.057,43.857c0.491,0,0.982-0.193,1.35-0.575L27.35,30.854l20.897,7.689c0.714,0.261,1.512,0.068,2.027-0.492    L69.517,17.06l4.502,3.764c0.221,0.184,0.528,0.216,0.782,0.084c0.253-0.133,0.403-0.404,0.377-0.691L74.202,9.305    c-0.034-0.39-0.379-0.677-0.768-0.642L62.521,9.637c-0.285,0.025-0.527,0.221-0.613,0.494c-0.027,0.09-0.036,0.183-0.028,0.274    c0.017,0.184,0.104,0.358,0.251,0.48l4.512,3.771l-18.279,19.94l-20.866-7.678c-0.699-0.255-1.481-0.075-1.997,0.459    L12.708,40.688c-0.716,0.746-0.693,1.93,0.053,2.646C13.123,43.683,13.59,43.857,14.057,43.857z" />
	</g>
    </SvgIcon>
  );
};
// IconMainMenu = pure(IconMainMenu);
IconMainMenu.displayName = 'IconMainMenu';
IconMainMenu.muiName = 'SvgIcon';

export default IconMainMenu;



// WEBPACK FOOTER //
// ./src/components/Icons/IconDashboard.js